import React from 'react';
import type { LstStatus } from '../../types';
import { meuPadraoIsLate } from '../../utils/meuPadraoDayUtils';
import type { LstRotinaDoDia } from '../../types';

export type MeuPadraoAgendaStatus = LstStatus | 'pendente' | 'agendado';

interface MeuPadraoAgendaBadgeProps {
  status: MeuPadraoAgendaStatus;
  rotina?: LstRotinaDoDia;
  isActive?: boolean;
  className?: string;
}

const base = 'inline-flex shrink-0 items-center rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide';

/** Badges de agenda operacional — Meu Padrão. */
export const MeuPadraoAgendaBadge: React.FC<MeuPadraoAgendaBadgeProps> = ({
  status,
  rotina,
  isActive = false,
  className = '',
}) => {
  if (isActive) {
    return (
      <span className={`${base} bg-[#2F6FED] text-white ring-2 ring-blue-200 dark:ring-blue-800 ${className}`}>
        Executando
      </span>
    );
  }

  if (status === 'pendente' || status === 'agendado') {
    return (
      <span className={`${base} bg-slate-100 text-slate-600 ring-1 ring-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:ring-slate-700 ${className}`}>
        Planejada
      </span>
    );
  }

  if (status === 'realizado') {
    return (
      <span className={`${base} bg-emerald-50 text-emerald-800 ring-1 ring-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:ring-emerald-800 ${className}`}>
        Concluída
      </span>
    );
  }

  if (status === 'realizado_com_desvio') {
    return (
      <span className={`${base} bg-amber-50 text-amber-800 ring-1 ring-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:ring-amber-800 ${className}`}>
        Desvio
      </span>
    );
  }

  if (status === 'processo_parado') {
    return (
      <span className={`${base} bg-slate-200 text-slate-600 ring-1 ring-slate-300 dark:bg-slate-700 dark:text-slate-300 ${className}`}>
        Linha parada
      </span>
    );
  }

  const late = rotina ? meuPadraoIsLate(rotina, status) : true;
  if (late) {
    return (
      <span className={`${base} bg-red-50 text-red-700 ring-1 ring-red-200 dark:bg-red-950/40 dark:text-red-300 dark:ring-red-900 ${className}`}>
        Atrasada
      </span>
    );
  }

  return (
    <span className={`${base} bg-red-50 text-red-700 ring-1 ring-red-200 dark:bg-red-950/40 dark:text-red-300 dark:ring-red-900 ${className}`}>
      Atrasada
    </span>
  );
};

export default MeuPadraoAgendaBadge;
